<script setup lang="ts">
import { twMerge } from 'tailwind-merge';

// PROPS
interface Props {
    email: string;
    label?: string;
    class?: string;
}

const { class: className } = defineProps<Props>();

// COMPOSABLES
const { trackEmailLink } = useTracking();

// DATA
const mergedClass = twMerge('text-primary underline', className);
</script>

<template>
    <a :href="`mailto:${email}`" :class="mergedClass" @click="trackEmailLink(email)">
        <slot>{{ label ?? email }}</slot>
    </a>
</template>
